export enum ShopMode {
  LocalDelivery = 'local-delivery',
  DirectSale = 'direct-sale',
}

export interface ShopModeState {
  mode: ShopMode | null;
}

// Action Types
export const SET_SHOP_MODE = 'SET_SHOP_MODE';

// Action Interfaces
export interface SetShopModeAction {
  type: typeof SET_SHOP_MODE;
  payload: ShopMode;
}

export type ShopModeActionTypes = SetShopModeAction;
